import { Component, input } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { EquipmentWoItem } from './po-line-item.model'
import { PoCommonFieldsComponent } from './po-common-fields.component'

@Component({
    selector: 'app-equipment-wo-form',
    templateUrl: './equipment-wo-form.component.html',
    standalone: true,
    imports: [FormsModule, PoCommonFieldsComponent],
})
export class EquipmentWoFormComponent {
    item = input.required<EquipmentWoItem>()
}
